import { API } from '../../../../config'
import { errorHandler } from '../../auth/errorAction'

export const unmountIndexCountry = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_MASTER_COUNTRY'})
}

export const indexCountry = () => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_MASTER_COUNTRY' })
  return API.GET('/country/index').then((response) => {
    dispatch({
      type: 'LOAD_DATA_MASTER_COUNTRY_SUCCESS', 
      payload: {
        data: response.data
    }})
  }).catch((err) => {
    return dispatch(errorHandler(
      err.error || err.message, 
      dispatch({ type: 'LOAD_DATA_MASTER_COUNTRY_FAILED' }), 
    ))
  })
}